import todoTypes from "../../../../constants/todoTypes";

import getProductionManagers from "../../helpers/team/managers/getProductionManagers";

import createTodoData from "../todos/createTodoData";

export default function createSubcontractorUploadedFilesTodoData(firebase, { production, files }) {
	const productionManagers = getProductionManagers({ production });

	return createTodoData(firebase, {
		type: todoTypes.SUBCONTRACTOR_UPLOADED_FILES,
		organizationIds: [production.producer],
		userIds: productionManagers.map((pM) => pM.id),
		users: productionManagers,
		subjectRef: production.ref,
		url: `/production/${production?.id}/articles`,
		notification: true,
		languages: [production.language],
		content: {
			files,
			production: {
				id: production.id,
				title: production.title,
			},
			publisher: {
				id: production.publisher,
				name: production.publisherName,
			},
		},
	});
}
